<template>

    <!-- 主容器 -->
    <div class="yx-div">
        <div style="position: absolute; margin-top: -10px; z-index: 99;">
            <span style="font-size: 13px; font-weight: bold; color: orange ">{{this.$router.currentRoute.name}}</span>
        </div>

    <!-- 工具栏-->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div  class="yx-flex-h-start2" style="margin-top: 5px;">
                    <!--
                    <div style="margin-right: 15px;">
                        汇总方式：
                        <el-radio-group v-model="searchVal.totalType" @change="searchDo" size="mini">
                            <el-radio-button label="1">终端</el-radio-button>
                            <el-radio-button label="2">支付渠道</el-radio-button>
                            <el-radio-button label="3">支付方式</el-radio-button>
                        </el-radio-group>
                    </div>-->

                    <div>
                        汇总条件：<el-select @change="searchDo" multiple clearable v-model="searchVal.totalTypes" placeholder="请选择汇总条件" size="mini" style="width: 350px;margin-right: 15px;">
                        <el-option class="f12"
                                   v-for="item in this._enums.MchBillTotalTypeEnum"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    </div>
                    <div>
                        交易日期：
                        <el-date-picker
                                v-model="searchVal.transDateScope"
                                value-format="yyyy-MM-dd"
                                type="daterange"
                                size="mini"
                                style="width:250px"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                </div>
                <div>
                    <el-button v-if="1===2" icon="el-icon-refresh" type="primary" plain @click="searchReset">重置</el-button>
                    <el-button type="primary" icon="el-icon-search" @click="searchDo">查询</el-button>
                </div>
            </div>
        </div>



        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                    :data="transs"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%;">
                <el-table-column prop="mchInfo.mchName" label="商户名称" align="center" width="200" show-overflow-tooltip />
                <el-table-column prop="mchInfo.mchNo" label="商户号" align="center" width="160" />
                <el-table-column prop="mchTerInfo.terNo" label="终端号" align="center" width="100" show-overflow-tooltip >
                    <!--
                    <template slot-scope="scope">
                        81923021
                    </template>
                    -->
                </el-table-column>
                <el-table-column prop="mchTerInfo.terName" label="终端名称" width="120" show-overflow-tooltip >
                    <!--
                    <template slot-scope="scope">
                        技能费
                    </template>
                    -->
                </el-table-column>
                <el-table-column prop="payWayCode" label="支付渠道" align="center" width="80" v-if="-1!==searchVal.totalTypes.indexOf(this._enums.MchBillTotalTypeEnum.支付渠道.id)" >
                    <template slot-scope="scope">
                        {{_enums.PayWayEnum.getNameById(scope.row.payWayCode)}}
                    </template>
                </el-table-column>
                <el-table-column prop="payModeCode" label="支付方式" align="center" width="80" v-if="-1!==searchVal.totalTypes.indexOf(this._enums.MchBillTotalTypeEnum.支付方式.id)" >
                    <template slot-scope="scope">
                        {{_enums.PayModeEnum.getNameById(scope.row.payModeCode)}}
                    </template>
                </el-table-column>
                <el-table-column prop="paySuccTime" label="交易日期" align="center" width="100" :formatter="funDateFormatter" v-if="-1!==searchVal.totalTypes.indexOf(this._enums.MchBillTotalTypeEnum.交易日期.id)" />
                <el-table-column prop="amount" label="交易金额" align="right" width="150" :formatter="funFmtTransAmt" />
                <!--
                <el-table-column prop="amount" label="手续费" align="right" width="100" :formatter="funFmtTemp" />
                <el-table-column prop="amount" label="实拨金额" align="right" width="150" :formatter="funFmtTransAmt" />
                -->
                <el-table-column prop="cnt" label="交易笔数" align="center" width="100" />
            </el-table>

        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-end">
            <el-pagination
                    :current-page.sync="page"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    layout="sizes, prev,pager,next, jumper,->, total, slot"
                    :total="total">
            </el-pagination>
        </div>

    </div>

</template>

<script>
    // name 组件名
    // data return 组件内的变量声明
    // created:html加载完成前 执行。执行顺序:父组件-子组件
    // mounted:html加载完成后 执行。执行顺序:子组件-父组件
    // methods:事件方法
    // watch:去监听一个值的变化，然后执行相对应的函数
    // computed:computed是属性调用，而methods是函数调用，computed带有缓存功能，而methods不是
    export default {
        name: "BillTotals",
        //组件中的data和实例中的不一样，实例中的data是一个对象，而组件中的data则是一个方法并且返回一个对象
        data() {
            //所有的变量都是写在data 的return里面
            //使用return包裹后数据中变量只在当前组件中生效,不会影响其他组件。
            return {
                searchVal: {
                    terNo : null,
                    payWayCode : null,
                    payModeCode : null,
                    transType : null,
                    transResult : null,
                    totalType : '1',
                    totalTypes : [],
                    totalTypesTmp : [],
                    transDateScope : null
                },
                loading: false, // 加载提示 v-loading 变量
                total: 0,       // 总计 变量
                page: 1,        // 页数 变量
                size: 10,       // 每页大小 变量

                acqChannels :[],   // 交易渠道 集合
                transs: [],   // 交易对象 数组变量
                oneTransDetail: null,
                transJnlKey: {
                    sysDate:'',
                    sysTime:'',
                    sysSerial:''
                }
            }
        },
        mounted() {
            this.initTransTotal();
        },
        methods: {
            searchReset() {
//                this.searchVal = {};
                this.searchVal.transDateScope = null;
                this.searchVal.totalTypes = [];
            },
            searchDo() {
                this.page = 1;
                this.initTransTotal();
            },
            initTransTotal() {
                this.loading = true;
                let url = '/bill/totals/?page=' + this.page + '&size=' + this.size;

                if (this.searchVal.totalTypes) {
                    url += '&totalTypes=' + this.searchVal.totalTypes;
                }
                if (this.searchVal.transDateScope) {
                    url += '&transDateScope=' + this.searchVal.transDateScope;
                }


                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        /*
                        this.searchVal.totalTypesTmp = [];
                        Object.assign(this.searchVal.totalTypesTmp, this.searchVal.totalTypes);
                        console.log(JSON.stringify(this.searchVal.totalTypesTmp));
                        */
                        this.transs = resp.data;
                        this.total = resp.total;
                        console.log("交易总笔数："+this.total);
                    }
                });
            },
            exportData() {
                window.open('/bill/export', '_parent');
            },
            initTransAcqChannels() {
                this.getRequest('/bill/acqChannel').then(resp => {
                    if (resp) {
                        this.acqChannels = resp;
                        window.sessionStorage.setItem("acqChannels", JSON.stringify(resp));
                    }
                })
            },
            funFmtTransAmt(row, column) {
                return row.amount.toFixed(2);
            },
            funFmtTemp(row, column) {
                return '0.00';
            },
            // 日期格式化
            funDateFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(0,10);
                }
                return tm;
            },
            // 时间格式化
            funTimeFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(11,19);
                }
                return tm;
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initTransTotal();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initTransTotal();
            },
        }
    }
</script>

<style>

    .pageNormal {
        font-size: 13px;
        font-family: 微软雅黑;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
    }

    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .5s ease;
    }

    .slide-fade-leave-active {
        transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }

    .style-input-width {
        max-width: 120px;
    }

    .xtable{position:absolute;bottom:100px;}
    .xfooter{position:absolute;bottom:0;width:100%;height:100px;background-color: #ffc0cb;}

</style>
